export class CompanyStatus {
    company_status_id ?= '';
    company_status ?= '';
    company_status_class ?= '';
}


// WEBPACK FOOTER //
// ./src/app/type/company-status.ts